import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { OfbizField, OfbizForm, OfbizFormsService } from '@urbannex/ofbiz-forms';

@Component({
  selector: 'ubs-edit-blog-description',
  templateUrl: './edit-blog-description.component.html',
  styleUrls: ['./edit-blog-description.component.scss']
})
export class EditBlogDescriptionComponent implements OnInit,OnChanges {
  @Input() description:string;
  @Input() formGroupName: string;
  @Input() ofbizForm:OfbizForm;
  @Input() fields:OfbizField[];
  initialState = "view";
  form: FormGroup;
  hasChanged:boolean = false;
  
  @Output() descriptionSubmit = new EventEmitter<string>();

  constructor(private rootFormGroup: FormGroupDirective) { }

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["formGroupName"]){
      this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
      //console.log(JSON.stringify(this.rootFormGroup.value));
    }
  }

  submit(){
    console.log(JSON.stringify(this.form.value));
    console.log(JSON.stringify(this.rootFormGroup.value));
    this.descriptionSubmit.emit(this.form.value); 
   }

   onChangeEvent(e){
    console.log("Has changed ....");
    this.hasChanged = true;
  }
  reset(){
    this.form.get("description").setValue(this.description);
  }

}
